import { VideoBlokProps } from "storyblok/components";
import { useState } from "react";

import { Container, VideoPlayer } from "components/ui";

import {
    BackgroundColor,
    Description,
    TextSection,
    Title,
    VideoWrapper,
    Wrapper
} from "./VideoBlok.styled";

import { optimizeImage } from "helpers/util/optimizeImage";
import { useMediaQueryContext } from "helpers/hooks";

export function VideoBlok({ blok }: VideoBlokProps) {
    const { isTabletViewOrLarger } = useMediaQueryContext();
    const [roundedCorners, setRoundedCorners] = useState(true);

    const { title, video, poster, description } = blok;

    const posterUrl = optimizeImage(poster.filename, "", true);

    return (
        <BackgroundColor>
            <Container>
                <Wrapper>
                    {!isTabletViewOrLarger && (
                        <>
                            {title && <Title>{title}</Title>}
                            <VideoWrapper
                                onClick={() =>
                                    setRoundedCorners(!roundedCorners)
                                }
                                roundedCorners={roundedCorners}
                            >
                                {video.filename && (
                                    <VideoPlayer
                                        url={video.filename}
                                        poster={posterUrl}
                                    />
                                )}
                            </VideoWrapper>
                            {description && (
                                <Description>{description}</Description>
                            )}
                        </>
                    )}

                    {isTabletViewOrLarger && (
                        <>
                            <VideoWrapper
                                onClick={() =>
                                    setRoundedCorners(!roundedCorners)
                                }
                                roundedCorners={roundedCorners}
                            >
                                <VideoPlayer
                                    url={video.filename}
                                    poster={posterUrl}
                                />
                            </VideoWrapper>
                            <TextSection>
                                <Title>{title}</Title>
                                <Description>{description}</Description>
                            </TextSection>
                        </>
                    )}
                </Wrapper>
            </Container>
        </BackgroundColor>
    );
}
